type Category = "static" | "gmd" | "legacy";

export const productCategoryConstants: Record<Category, Category> = {
  static: "static",
  gmd: "gmd",
  legacy: "legacy"
};
